module.exports = __webpack_public_path__ + "img/logo-color.5563ba91.png";